module.exports = __webpack_public_path__ + "media/images/bundle-optima@2x-81325620f221c2d584946db287743f04.png";